import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StartCountDown',
  props: {
    time: {}
  },
  emits: ["sendVerificationCode"],
  setup(__props: any, { emit }) {

const props = __props;

/* eslint-disable */


const { time } = reactive(props);
const isbtn = reactive(// 按钮是否为发送验证码之前的样式
    {
        // background: '#cdcdcd',
        color: "#5c4824",
        fontSize: "16px",
        // outline:'1px solid #fc8f28'
        boxShadow: "inset 0px 0px 16px 0px rgb(255, 241, 221)",
        border: '1.5px solid rgba(255, 147, 5)',
    }
);
const count = ref<number>(0); // 验证码按钮显示
// 获取验证码倒计时
const startCountdown = () => {
    if (count.value == 0) {
        emit('sendVerificationCode'); // 触发父组件事件
        count.value = time ?? 60;
        let intervalId = setInterval(() => {
            count.value -= 1;
            if (count.value == 0) {
                clearInterval(intervalId); // 清除定时器
            }
        }, 1000)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn",
    style: _normalizeStyle(count.value > 0 ? isbtn : ''),
    onClick: startCountdown
  }, _toDisplayString(count.value == 0 ? '获取验证码' : '重新发送 ' + count.value + 's'), 5))
}
}

})